import { createSelector } from "reselect";
import { RootState } from "@lib/redux/types";

const selectNotifications = (state: RootState) => state.notifications;
export const selectNotificationsToasts = createSelector(
  selectNotifications,
  (notifications) => notifications.toasts,
);
